export const EMPTY_ARRAY = [];

// Column name for gene names in the annomatrix
export const VAR_FEATURE_NAME_COLUMN = "feature_name";
